import { Quill } from 'react-quill'

export const registerImageBlot = () => {
    class ImageBlot extends Quill.import('blots/block/embed') {
        static create(value) {
            let node = super.create()
            node.setAttribute('id', value.id)
            node.setAttribute('alt', value.alt)
            node.setAttribute('src', value.url)
            return node
        }

        static value(node) {
            return {
                id: node.getAttribute('id'),
                alt: node.getAttribute('alt'),
                url: node.getAttribute('src'),
            }
        }
    }
    ImageBlot.blotName = 'image'
    ImageBlot.tagName = 'img'

    Quill.register(ImageBlot)
}
